<template>
  <div
    v-if="symbol.type === 'Vertical Divider Line'"
    :class="symbolClasses"
  ></div>
  <hr v-else :class="symbolClasses" v-html="symbol.content" />
</template>

<script>
  export default {
    props: ['symbol'],
    computed: {
      symbolClasses() {
        const styles = {
          'Vertical Divider Line': 'hr hr--vertical-divider',
          'Full Divide No Padding': 'border-t-0 pt-0 mb-0 border-b-1',
          'Small Divide Line': 'hr hr--short-divider border-b-1',
          'Full Width Divider': 'hr border-b-1',
          'Thick Full Width Divider': 'hr border-b-3',
        };
        const colors = {
          Teal: 'border-teal',
          Grey: 'border-gray-light',
          White: 'border-white',
          Navy: 'border-blue-dark',
          Default: 'border-blue-dark',
          'Dark Grey': 'border-gray-dark',
          Green: 'border-green',
          'Light Grey': 'border-gray-light',
          Blue: 'border-blue',
        };
        const color = this.$props.symbol.color
          ? colors[this.$props.symbol.color]
          : colors['Default'];
        const alignments = {
          Default: 'mx-auto',
          Left: 'ml-0 mr-auto',
          Center: 'mx-auto',
          Right: 'ml-auto mr-0',
        };
        const alignment = this.$props.symbol.alignment
          ? alignments[this.$props.symbol.alignment]
          : alignments['Default'];
        return `${styles[this.$props.symbol.type]} ${color} ${alignment}`;
      },
    },
  };
</script>
